import script from "./InternalInspectionAnswerIssues.vue?vue&type=script&lang=ts&setup=true"
export * from "./InternalInspectionAnswerIssues.vue?vue&type=script&lang=ts&setup=true"

import "./InternalInspectionAnswerIssues.vue?vue&type=style&index=0&id=7f894f1a&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f894f1a"]])

export default __exports__